<template>
    <div>
        <card-header title="Conference Details" icon="fa-presentation" />

        <card-toolbar>
            <button @click="$openCard('edit-conference', {confId: conference.id}, card)"><i class="far fa-pencil"></i>Edit Details</button>
            <button @click="view"><i class="far fa-external-link-alt"></i>View</button>
            <button @click="$openCard('conf-communicate', {confId: conference.id}, card)"><i class="far fa-comment"></i>Communicate</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <conference-tile :card="card" :conf="conference" :summary="false" />
                <subheader-list-item title="Overview" icon="fa-align-left" />
                <container-list-item>
                    <data-row title="Conference Code">
                        <b-tag type="is-primary"><i class="far fa-tag ml-1 mr-1"></i> {{ conference.code }}</b-tag>
                    </data-row>
                    <data-row title="Dates">{{ confDates }}</data-row>
                    <data-row title="Registration Open">{{ regDates }}</data-row>
                    <data-row title="Registrations">{{ conference.registrations.length }} ({{ conference.pending }} pending)</data-row>
                    <data-row title="Revenue">
                        {{ conference.revenue | currency }} ({{ conference.pendingRevenue | currency }} pending)<br/>
                        <div class="mt-1">
                            <small>{{ ccRegistrations.revenue | currency }} (Credit Card), {{ poRegistrations.revenue | currency }} (Purchase Order)</small>
                        </div>
                    </data-row>
                </container-list-item>

                <subheader-list-item title="Registrations" icon="fa-users" />
                <search-list-item @action="searchRegistrations" />
                <separator-list-item />

                <navigation-list-item
                    @click="$openCard('registrations', {type: 'all', confId: conference.id}, card)"
                    title="All Registrations" icon="fa-users"
                    :badge="conference.registrations.length"
                    :active="(child && child.definition.component === 'registrations' && conference.id === parseInt(child.props.confId) && 'all' === child.props.type)"
                />

                <navigation-list-item
                    v-if="conference.pending > 0"
                    @click="$openCard('registrations', {type: 'pending', confId: conference.id}, card)"
                    title="Pending" icon="fa-exclamation-triangle has-text-warning"
                    :badge="conference.pending"
                    :active="(child && child.definition.component === 'registrations' && conference.id === parseInt(child.props.confId) && 'pending' === child.props.type)"
                />

                <navigation-list-item
                    v-if="conference.pending > 0"
                    @click="$openCard('registrations', {type: 'complete', confId: conference.id}, card)"
                    title="Registered" icon="fa-check"
                    :badge="conference.registrations.length - conference.pending"
                    :active="(child && child.definition.component === 'registrations' && conference.id === parseInt(child.props.confId) && 'complete' === child.props.type)"
                />

                <navigation-list-item
                    @click="$openCard('registrations', {type: 'cc', confId: conference.id}, card)"
                    title="Credit Card" icon="fa-credit-card"
                    :badge="ccRegistrations.count"
                    :active="(child && child.definition.component === 'registrations' && conference.id === parseInt(child.props.confId) && 'cc' === child.props.type)"
                />

                <navigation-list-item
                    @click="$openCard('registrations', {type: 'po', confId: conference.id}, card)"
                    title="Purchase Order" icon="fa-file-invoice"
                    :badge="poRegistrations.count"
                    :active="(child && child.definition.component === 'registrations' && conference.id === parseInt(child.props.confId) && 'po' === child.props.type)"
                />

                <navigation-list-item
                    @click="$openCard('registrations', {type: 'access', confId: conference.id}, card)"
                    title="Complimentary/Staff" icon="fa-id-badge"
                    :badge="accessRegistrations.count"
                    :active="(child && child.definition.component === 'registrations' && conference.id === parseInt(child.props.confId) && 'access' === child.props.type)"
                />

                <separator-list-item />

                <navigation-list-item
                    @click="$openCard('registrations', {type: type.id, confId: conference.id}, card)"
                    :title="type.title"
                    :badge="getCount(type.id)"
                    icon="fa-people-group"
                    :active="(child && child.definition.component === 'registrations' && conference.id === parseInt(child.props.confId) && type.id === parseInt(child.props.type))"
                    v-for="type in conference.regTypes"
                />


                <subheader-list-item title="Setup" icon="fa-cogs" />

                <navigation-list-item
                    title="Conference Details"
                    icon="fa-presentation"
                    @click="$openCard('edit-conference', {confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'edit-conference' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item
                    title="Sessions"
                    icon="fa-users-class"
                    @click="$openCard('conf-sessions', {confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'conf-sessions' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item
                    title="Registration Types/Fees"
                    icon="fa-people-group"
                    @click="$openCard('conf-reg-types', {confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'conf-reg-types' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item
                    title="Registration Questions"
                    icon="fa-question-circle"
                    @click="$openCard('conf-questions', {confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'conf-questions' && conference.id === parseInt(child.props.confId))"
                />

                <!--                <navigation-list-item title="Add-ons" icon="fa-layer-plus"/>-->

                <navigation-list-item
                    title="Discount Codes"
                    icon="fa-tags"
                    @click="$openCard('conf-discounts', {confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'conf-discounts' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item
                    title="Certification Applications"
                    icon="fa-file-certificate"
                    @click="$openCard('conf-applications', {confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'conf-applications' && conference.id === parseInt(child.props.confId))"
                />

                <navigation-list-item
                    title="Assigned Users"
                    icon="fa-user-check"
                    @click="$openCard('conf-assigned-users', {confId: conference.id}, card)"
                    :active="(child && child.definition.component === 'conf-assigned-users' && conference.id === parseInt(child.props.confId))"
                />

                <!--                <navigation-list-item-->
                <!--                    title="Surveys"-->
                <!--                    icon="fa-poll-people"-->
                <!--                    @click="$openCard('-surveys', {confId: conference.id}, card)"-->
                <!--                    :active="(child && child.definition.component === '-surveys' && conference.id === parseInt(child.props.confId))"-->
                <!--                />-->

            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import ConferenceTile from "../../components/tiles/ConferenceTile";

    import {client as http} from "@/http_client";
    import moment from "moment";

    export default {
        props: ['card', 'child', 'props'],
        components: {ConferenceTile, ContainerListItem, SeparatorListItem, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                conference: {
                    registrations: []
                }
            };
        },
        methods: {
            loadConference: function (force) {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('title', response.data.title);
                    this.$emit('loading', false);
                });
            },
            view: function () {
                window.open('https://app.my247ed.com/#/register/' + this.conference.code)
            },
            reload: function () {
                this.loadConference(true);
            },
            getCount: function (typeId) {
                return this.conference.registrations.filter(r => r.reg_type_id === typeId).length;
            },
            searchRegistrations: function (query) {
                this.$openCard('registration-search', {query, confId: this.props.confId, type: 'all'}, this.card);
            },
        },
        computed: {
            confDates: function () {
                let s = moment(this.conference.start_at);
                let e = moment(this.conference.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
            regDates: function () {
                let s = moment(this.conference.open_at);
                let e = moment(this.conference.close_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
            ccRegistrations: function () {
                let registrations = this.conference.registrations.filter(r => r.payment_type === 'cc');
                return {
                    registrations,
                    count: registrations.length,
                    revenue: registrations.reduce((a, r) => a + r.revenue, 0),
                };
            },
            poRegistrations: function () {
                let registrations = this.conference.registrations.filter(r => (r.payment_type === 'po'));
                let completeRegistrations = this.conference.registrations.filter(r => (r.payment_type === 'po' && r.is_po_pending === 0));
                return {
                    registrations,
                    count: registrations.length,
                    revenue: completeRegistrations.reduce((a, r) => a + r.revenue, 0),
                    pending: registrations.filter(r => r.is_po_pending === 1).length,
                };
            },
            accessRegistrations: function () {
                let registrations = this.conference.registrations.filter(r => r.payment_type === 'access');
                return {
                    registrations,
                    count: registrations.length,
                    revenue: registrations.reduce((a, r) => a + r.revenue, 0),
                };
            },
        },
        watch: {
            'props.confId': function () {
                this.loadConference();
            }
        },
        mounted: function () {
            this.loadConference();
        }
    };
</script>

